import { TFunction } from 'i18next';

import { formatMoneyWithZeroCents } from 'utils/money';

import { Answers } from 'types/zod/answers';
import { type Question } from 'types/zod/question';
import { type Widget } from 'types/zod/widget';

export default class LoopService {
    enhanceAnswer = (answer: Answers, question: Question, documentType: string, t: TFunction) => {
        const widgetType = ((question._widget || {}) as Widget).type;
        const keys = Object.keys(answer);

        if (widgetType === 'radio' || widgetType === 'check') {
            const questionOptions = Object.keys(question);

            answer._selectedValue = keys
                .filter((key) => questionOptions.indexOf(key) > -1)
                .map((key) => t(`${documentType}:${key}`))
                .join('; ');
        }
        keys.forEach((key) => {
            if (
                question[key] &&
                question[key]._widget &&
                ['numeric', 'money'].includes((question[key]._widget as Widget).type) &&
                answer[key] !== null
            ) {
                answer[key + '_dollarValue'] = formatMoneyWithZeroCents(answer[key]);
            }

            if (answer[key] === Object(answer[key]) && question[key]) {
                this.enhanceAnswer(answer[key], question[key] as Question, documentType, t);
            }
        });

        return answer;
    };

    roundTo2Decimals = (n: number) => {
        return Number(Number(n).toFixed(2));
    };
}
